import teras from '@/teras'

import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '@/components/Login'
import Home from '@/components/Home'

import ContattoEdit from '@/components/Contatto-edit'
import ContattoPassword from '@/components/Contatto-password'
import ContattoRinnovo from '@/components/Contatto-rinnovo'
import SellaBack from '@/components/Sella-back'
import SellaBackError from '@/components/Sella-back-error'

Vue.use(VueRouter)

var mode = (process.env.NODE_ENV != 'development') ? 'history' : 'hash'

const router = new VueRouter({

  mode: mode,
  base: '/tesoreria/',

  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  },

  routes: [
    { path: '/', name: 'root', meta: { requiresEvent: false, requiresAuth: true }, components:{main: Home  }},

    
    { path: '/login', name: 'login', meta: { requiresAuth: false }, components:{main: Login  } }, 
    { path: '/home', name: 'home', meta: { requiresAuth: true }, components:{main: Home  }}, 

    { path: '/contatto-edit', name: 'contatto.edit', meta: { requiresAuth: true }, components: { main: ContattoEdit } }, 
    { path: '/contatto-password', name: 'contatto.password', meta: { requiresAuth: true }, components: { main: ContattoPassword } }, 
    { path: '/contatto-rinnovo', name: 'contatto.rinnovo', meta: { requiresAuth: true }, components: { main: ContattoRinnovo } },
    { path: '/sella-back-error', name: 'sella.back.error', meta: { requiresAuth: true }, components:{main: SellaBackError  }},
    { path: '/sella-back', name: 'sella.back', meta: { requiresAuth: false }, components:{main: SellaBack  } }, 

    { path: '*', redirect: '/home' } 
  ]


})



router.beforeEach(async (to, from, next) => {
  console.log("beforeEach")
  let error = false

 
  teras.app.drawer = false
  //to.query contiene le variabili passate in modo standard es. ?variabile=valore
  //to.params contiene le variabili passate in vuejs passate in base a routes[]
  console.log("\nbeforeEach \ncheckFirst: "+router.checkFirst+"\nfrom: "+from.path+"\nto: "+to.path+"\n\n")
  teras.router.from = from.path
  teras.router.to = to.path
 /* */
 if (!teras.check.first){
  console.log("SONO RICHIESTE LE OPERAZIONI DI PRIMO AVVIO")
  await checkFirst(to)
}
 
  console.log("AUTH FROM ROUTER "+teras.check.auth)
  if (!error && to.matched.some(record => record.meta.requiresAuth) && !teras.check.auth){
    console.log("È RICHIESTO UTENTE E NON È ANCORA VERIFICATO")
    teras.event.emit('checkAuth', from, to)
    error = true
  }
  if(error){
      console.log("beforeEach next is false")
      next(false)
  }else{
      console.log("beforeEach next")
      teras.app.ready = true
      next()
      teras.event.emit('routerChange', to)
  }

})

export default router
